<template>
  <v-card
    outlined
    class="pa-2 my-1"
    :color="colorByStatusWithTransparency"
    :style="productStyle"
  >
    <div>{{ product.name }}</div>
    <v-chip
      outlined
      exact
      small
      :color="colorByStatusStronger"
      v-for="option in product.options"
      :key="option.name"
      class="font-italic"
    >
      {{ option.name }}
    </v-chip>
    <div class="font-italic body-2" :style="`color:${colorByStatus};`">
      {{ product.comment }}
    </div>
  </v-card>
</template>

<script>
import { OrderProductStatus } from "@/model/order";

export default {
  props: {
    product: {},
    isOrderFinished: { default: false, type: Boolean },
    isSelected: { default: false, type: Boolean }
  },
  computed: {
    colorByStatus() {
      switch (this.product.status) {
        case OrderProductStatus.preparing:
          return "#e35252";
        case OrderProductStatus.ready:
          return "#50c79b";
        case OrderProductStatus.delivered:
          return this.isOrderFinished ? "#d1d1d1" : "#33a7ff";
      }
      return "#d1d1d1";
    },

    colorByStatusWithTransparency() {
      return `${this.colorByStatus}11`;
    },

    colorByStatusStronger() {
      switch (this.product.status) {
        case OrderProductStatus.preparing:
          return "#b34040";
        case OrderProductStatus.ready:
          return "#388c6d";
        case OrderProductStatus.delivered:
          return this.isOrderFinished ? "#999999" : "#2472b3";
      }
      return "#999999";
    },

    productStyle() {
      let borderColor = this.colorByStatus;
      let fontColor = this.colorByStatusStronger;
      let style = `border-color: ${borderColor}; color: ${fontColor};`;
      if (this.isSelected) {
        return `${style} font-weight: bold; box-shadow: 0 0 10px ${borderColor}`;
      }
      return style;
    }
  }
};
</script>
